import React from 'react'
import _ from 'lodash'
import { Switch, Tooltip } from 'antd'
import { Icon, Div, P } from 'konsys-ui'
import {
  InputWithPlaceHolder, ActionSelector, HeaderLabel, CellText, DropdownSelector,
} from '../../../components/tire-inventory-components'
import { theme } from '../../../styles/_variables'
import { TIRETYPE } from '../constants'

const { color } = theme

export default {
  columns: [{
    Header: () => <HeaderLabel>รหัสสินค้า</HeaderLabel>,
    accessor: 'sku',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)} />,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 200,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ชื่อสินค้า</HeaderLabel>,
    accessor: 'productName',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)} />,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 300,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ประเภทยาง</HeaderLabel>,
    accessor: 'Tire.TireType.name',
    sortable: false,
    filterable: true,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <DropdownSelector
      key='filter'
      data={TIRETYPE}
      TireType={true}
      handleChange={e => onChange(e)}
      filter={true}
      statusAttr='ทั้งหมด'
    />,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 230,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ยี่ห้อ</HeaderLabel>,
    accessor: 'brand',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)} />,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>หน้ายาง</HeaderLabel>,
    accessor: 'inventoryOptions[0].option1.optionName',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)} />,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 100,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>แก้มยาง</HeaderLabel>,
    accessor: 'inventoryOptions[0].option2.optionName',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)} />,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 100,
    margin: '0 50px',
  }, {
    id: 'stockSummary',
    Header: () => <HeaderLabel>จำนวนสินค้า/สต๊อกขั้นต่ำ</HeaderLabel>,
    accessor: 'inventoryOptions[0]',
    sortable: false,
    filterable: true,
    Cell: (props) => {
      const stock = _.sumBy(props.value?.stockLocation, location => location.quantity)
      const minimumStock = props.value.minimumStock || 0
      const isLow = stock < minimumStock
      return (
        <CellText
          style={{
            color: isLow && color.primaryColor,
            fontWeight: isLow && 700,
          }}
        >
          {`${stock}/${minimumStock}`}
        </CellText>
      )
    },
    Filter: ({ onChange }) => (
      <div className='w-full flex justify-center items-center gap-x-2'>
        <Switch onChange={onChange} />
        <p className='text-xs font-medium'>แสดงเฉพาะสินค้า<br />ที่ต่ำกว่าสต๊อกขั้นต่ำ</p>
      </div>
    ),
    width: 200,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ขนาดกะทะล้อ</HeaderLabel>,
    accessor: 'inventoryOptions[0].option3.optionName',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)} />,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 100,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ผู้จำหน่าย</HeaderLabel>,
    accessor: 'supplier[0].name',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)} />,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector props={props} serial={props.tdProps.rest.serial} />,
    width: 150,
  }],
}
